// removed by extract-text-webpack-plugin
module.exports = {"scatterChart":"danger_scatterChart_1i7aK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/overview/subComponents/risk/danger.scss
// module id = 1549
// module chunks = 0